import { render } from "./AllTicketsAdminSos.vue?vue&type=template&id=7e0125a3&scoped=true&ts=true"
import script from "./AllTicketsAdminSos.vue?vue&type=script&lang=ts"
export * from "./AllTicketsAdminSos.vue?vue&type=script&lang=ts"

import "./AllTicketsAdminSos.vue?vue&type=style&index=0&id=7e0125a3&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0125a3"]])

export default __exports__